/** Keep private sign-in links out of browser error reports and navigation breadcrumbs. */
export function redactReviewerLink<T>(value: T): T {
  const seen = new WeakMap<object, unknown>();
  function redact(input: unknown, key = ''): unknown {
    if (typeof input === 'string') {
      if (key === 'token' && /^[a-f0-9]{64}$/i.test(input)) return '[redacted]';
      return input.replace(/([#?&]token=)[a-f0-9]{64}/gi, '$1[redacted]');
    }
    if (!input || typeof input !== 'object') return input;
    if (seen.has(input)) return seen.get(input);
    if (Array.isArray(input)) {
      const output: unknown[] = [];
      seen.set(input, output);
      input.forEach((item) => output.push(redact(item)));
      return output;
    }
    const prototype = Object.getPrototypeOf(input);
    if (prototype !== Object.prototype && prototype !== null) return input;
    const output: Record<string, unknown> = Object.create(null);
    seen.set(input, output);
    Object.entries(input).forEach(([name, item]) => {
      output[name] = redact(item, name);
    });
    return output;
  }
  return redact(value) as T;
}
